if (!customElements.get('ibd-measurements-component')) {
  customElements.define('ibd-measurements-component', class IBDMeasurementsComponent extends HTMLElement {
    /** @type {string} */
    dimensionUnit;

    /** @type {string} */
    weightUnit;

    /** @type {Record<string, any>} */
    measurements;

    /** @type {HTMLButtonElement} */
    toggleButton;

    connectedCallback() {
      const dimensionUnit = this.getAttribute('data-dimension-unit');
      if (!dimensionUnit) return;

      const weightUnit = this.getAttribute('data-weight-unit');
      if (!weightUnit) return;

      const measurementsJson = this.getAttribute('data-measurements-json');
      if (!measurementsJson) return;

      try {
        this.dimensionUnit = dimensionUnit;
        this.weightUnit = weightUnit;
        this.measurements = JSON.parse(measurementsJson);
      } catch (error) {
        console.error(error);
        return;
      }

      /** @type {HTMLButtonElement|null} */
      const toggleButton = this.querySelector('[data-toggle-unit]');
      if (!toggleButton) return;
      this.toggleButton = toggleButton;

      this.getNewMeasurements();
      this.toggleButton.addEventListener('click', this.toggleUnit.bind(this));
    }

    getNewMeasurements() {
      /** @type {NodeListOf<HTMLElement>} */
      const measurementItems = this.querySelectorAll('[data-measurement-item]');
      if (measurementItems.length === 0) return;

      const newMeasurements = Array.from(measurementItems).map((item) => {
        if (item.hidden) return;

        /** @type {HTMLElement|null} */
        const measurementValueEl = item.querySelector('[data-measurement-value]');

        /** @type {HTMLElement|null} */
        const measurementUnitEl = item.querySelector('[data-measurement-unit]');
        if (!measurementValueEl || !measurementUnitEl) return;

        /** @type {string|undefined} */
        const measurementItem = item.dataset.measurementItem;
        if (!measurementItem) return;

        const unitType = measurementItem === 'weight' ? 'weight' : 'dimension';
        const newUnit = unitType === 'weight' ? this.weightUnit === 'lb' ? 'kg' : 'lb' : this.dimensionUnit === 'in' ? 'cm' : 'in';
        const newUnitLabel = this.measurements[newUnit]['unit_label'];
        const newValue = this.measurements[newUnit][measurementItem];

        if (!newValue || !newUnitLabel) {
          if (this.toggleButton) this.toggleButton.disabled = true;
          throw new Error(`IBD | Error: "${measurementItem}" not found in measurements JSON`);
        }

        return {
          item: measurementItem,
          itemEl: item,
          value: newValue,
          valueEl: measurementValueEl,
          unit: newUnitLabel,
          unitEl: measurementUnitEl,
        };
      });

      return newMeasurements;
    }

    toggleUnit() {
      if (this.toggleButton.disabled) return;

      const newMeasurements = this.getNewMeasurements();
      if (!newMeasurements || newMeasurements.length === 0) return;

      newMeasurements.forEach((measurement) => {
        if (!measurement || !measurement.valueEl || !measurement.unitEl) return;
        measurement.valueEl.textContent = measurement.value;
        measurement.unitEl.textContent = measurement.unit;
      });

      const newToggleButtonAriaLabel = this.toggleButton.hasAttribute('data-show-weight')
        ? `Convert to ${this.dimensionUnit} and ${this.weightUnit}`
        : `Convert to ${this.dimensionUnit}`;
      this.toggleButton.setAttribute('aria-label', newToggleButtonAriaLabel);

      const newDimensionUnit = this.dimensionUnit === 'in' ? 'cm' : 'in';
      this.dimensionUnit = newDimensionUnit;
      this.dataset.dimensionUnit = newDimensionUnit;

      const newWeightUnit = this.weightUnit === 'lb' ? 'kg' : 'lb';
      this.weightUnit = newWeightUnit;
      this.dataset.weightUnit = newWeightUnit;
    }
  });
}
